import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M19.25 12V6C19.25 5.30964 18.6904 4.75 18 4.75H12M19.25 12V18C19.25 18.6904 18.6904 19.25 18 19.25H12M19.25 12H4.75M4.75 12V18C4.75 18.6904 5.30964 19.25 6 19.25H12M4.75 12V6C4.75 5.30964 5.30964 4.75 6 4.75H12M12 4.75V19.25" />
	</SVG>
);
